import { render, staticRenderFns } from "./ContributionsFileUpload.vue?vue&type=template&id=0fb9e80f&scoped=true"
import script from "./ContributionsFileUpload.vue?vue&type=script&lang=ts"
export * from "./ContributionsFileUpload.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsFileUpload.vue?vue&type=style&index=0&id=0fb9e80f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9e80f",
  null
  
)

export default component.exports